// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3xwLM","title":"ClientInsurance_title__2vUZe","itemText":"ClientInsurance_itemText__1Sefz"};